import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const authApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface LoginResponse {
  requires2FA: boolean;
  mustResetPassword: boolean;
  tempToken: string;
  resetToken: string;
  message: string;
}

export interface AuthResponse {
  token: string;
  nombre: string;
  email: string;
  userType: string;
}

export const authService = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await authApi.post<LoginResponse>('/auth/login', { email, password });
    return response.data;
  },

  verify2FA: async (tempToken: string, code: string): Promise<AuthResponse> => {
    const response = await authApi.post<AuthResponse>('/auth/verify-2fa', { tempToken, code });
    return response.data;
  },

  requestPasswordReset: async (email: string): Promise<{ message: string }> => {
    const response = await authApi.post<{ message: string }>('/auth/request-password-reset', { email });
    return response.data;
  },

  resetPassword: async (token: string, newPassword: string): Promise<{ message: string }> => {
    const response = await authApi.post<{ message: string }>('/auth/reset-password', { token, newPassword });
    return response.data;
  },
};
